module.exports = __webpack_public_path__ + "static/img/V-M60_ar@2x.9f7315b5.png";